import authProvider from 'src/auth/authProvider';
import { UserRole } from 'src/auth/types';
import { EducationLevel, EducationLevelGroup, FILTER_EMPTY_VALUE } from 'src/constants';
import {
    EducationLevelGroupDropdownList,
    EducationLevelGroupFullName,
    EducationLevelGroupList,
    HighSchoolEducationLevels,
    JuniorSchoolEducationLevels,
    PreSchoolEducationLevels
} from 'src/constants/children/form';
import {
    AdminGroup,
    HighSchoolRoles,
    JuniorSchoolRoles,
    PreSchoolRoles,
    SpecialTeachersGroup
} from 'src/constants/roles';

export const EMPLOYMENT_TYPE = 'employmentType';
export const EDUCATION_CENTER_ID = 'educationCenterId';
export const EDUCATION_LEVELS = 'educationLevels';
export const EDUCATION_LEVEL_GRADE = 'educationLevelGrade';
export const PRESCHOOL_EDUCATION_LEVEL = 'preSchoolEducationLevel';

export class ChildrenFilterManager {
    static filtersApplied: any = null;

    static isAdmin(): boolean {
        return authProvider?.containsRoles(AdminGroup);
    }
    static isPreSchool(): boolean {
        return authProvider?.containsRoles(PreSchoolRoles);
    }
    static isJuniorSchool(): boolean {
        return authProvider?.containsRoles(JuniorSchoolRoles);
    }
    static isHighSchool(): boolean {
        return authProvider?.containsRoles(HighSchoolRoles);
    }
    static isSpecial(): boolean {
        const roles = [...SpecialTeachersGroup, UserRole.SPECIAL_EDUCATION_TEACHER];
        return authProvider?.containsRoles(roles);
    }

    static isPsychologist(): boolean {
        return authProvider?.containsRoles(UserRole.PSYCHOLOGIST);
    }

    static defineFilters(filters: any): void {
        let educationLevelsFilter: EducationLevel[] = [];

        if (filters[EDUCATION_LEVELS]) {
            switch (filters[EDUCATION_LEVELS]) {
                case EducationLevelGroup.PRESCHOOL:
                    educationLevelsFilter = PreSchoolEducationLevels;
                    if (filters[PRESCHOOL_EDUCATION_LEVEL]) {
                        educationLevelsFilter = [filters[PRESCHOOL_EDUCATION_LEVEL] as EducationLevel];
                    }
                    break;
                case EducationLevelGroup.JUNIOR_SCHOOL:
                    educationLevelsFilter = JuniorSchoolEducationLevels;
                    if (filters[EDUCATION_LEVEL_GRADE]) {
                        educationLevelsFilter = [filters[EDUCATION_LEVEL_GRADE] as EducationLevel];
                    }
                    break;
                case EducationLevelGroup.HIGH_SCHOOL:
                    educationLevelsFilter = HighSchoolEducationLevels;
                    if (filters[EDUCATION_LEVEL_GRADE]) {
                        educationLevelsFilter = [filters[EDUCATION_LEVEL_GRADE] as EducationLevel];
                    }
                    break;
            }
        }

        if (filters[PRESCHOOL_EDUCATION_LEVEL]) {
            educationLevelsFilter = [...educationLevelsFilter, filters[PRESCHOOL_EDUCATION_LEVEL] as EducationLevel];
        }
        if (filters[EDUCATION_LEVEL_GRADE]) {
            educationLevelsFilter = [...educationLevelsFilter, filters[EDUCATION_LEVEL_GRADE] as EducationLevel];
        }

        filters.educationLevels = educationLevelsFilter;
    }

    static getFiltersDefaultValues(): Record<string, string> {
        return {
            [EMPLOYMENT_TYPE]: FILTER_EMPTY_VALUE,
            [EDUCATION_CENTER_ID]: FILTER_EMPTY_VALUE,
            [EDUCATION_LEVELS]: FILTER_EMPTY_VALUE,
            [EDUCATION_LEVEL_GRADE]: FILTER_EMPTY_VALUE,
            [PRESCHOOL_EDUCATION_LEVEL]: FILTER_EMPTY_VALUE
        };
    }
    static getPreSchoolChoices(): { id: EducationLevel; name: string }[] {
        const preSchoolEducationLevelChoices: { id: EducationLevel; name: string }[] = [
            ...EducationLevelGroupDropdownList[EducationLevelGroup.PRESCHOOL]
        ];
        return preSchoolEducationLevelChoices;
    }
    static getEducationLevelGradeChoices(): { id: EducationLevel; name: string }[] {
        const isJuniorSchool = this.isJuniorSchool();
        const isHighSchool = this.isHighSchool();
        const isAdmin = this.isAdmin();

        let educationLevelGradeChoices: { id: EducationLevel; name: string }[] = [];
        if (isJuniorSchool) {
            educationLevelGradeChoices = [...EducationLevelGroupList[EducationLevelGroup.JUNIOR_SCHOOL]];
        }
        if (isHighSchool) {
            educationLevelGradeChoices = [
                ...educationLevelGradeChoices,
                ...EducationLevelGroupList[EducationLevelGroup.HIGH_SCHOOL]
            ];
        }

        if (isAdmin) {
            educationLevelGradeChoices = [
                ...EducationLevelGroupList[EducationLevelGroup.JUNIOR_SCHOOL],
                ...EducationLevelGroupList[EducationLevelGroup.HIGH_SCHOOL]
            ];
        }
        return educationLevelGradeChoices;
    }
    static getEducationLevelChoices(): { id: EducationLevelGroup; name: string }[] {
        const educationLevelChoices: { id: EducationLevelGroup; name: string }[] = [
            {
                id: EducationLevelGroup.PRESCHOOL,
                name: `${EducationLevelGroupFullName[EducationLevelGroup.PRESCHOOL]}`
            },
            {
                id: EducationLevelGroup.JUNIOR_SCHOOL,
                name: `${EducationLevelGroupFullName[EducationLevelGroup.JUNIOR_SCHOOL]}`
            },
            {
                id: EducationLevelGroup.HIGH_SCHOOL,
                name: `${EducationLevelGroupFullName[EducationLevelGroup.HIGH_SCHOOL]}`
            }
        ];
        return educationLevelChoices;
    }
}
